/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';
import { ReportParams } from 'application/Shared/types/reports';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useState } from 'react';

import { Recipient } from './scheduledReports';

interface EmailReportFormValues {
    recipients: Recipient[];
    subject: string;
    description: string;
}

/**
 * Custom hook for sending email reports
 */
export const useEmailReport = (params: ReportParams) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const sendEmailReport = async (
        data: EmailReportFormValues
    ): Promise<boolean> => {
        setIsSubmitting(true);
        try {
            const { recipients, subject, description } = data;

            const payload = {
                description: description || '',
                params,
                recipients,
                subject: subject || ''
            };

            const response = await axios.post('/emailReport', payload);

            if (!Response.hasData(response, { noId: true })) {
                throw new Error('No email report response.');
            }

            setIsSubmitting(false);
            return true;
        } catch (e) {
            debug.error('Failed to send email report:', e);
            setIsSubmitting(false);
            return false;
        }
    };

    return {
        isSubmitting,
        sendEmailReport
    };
};
